export const SESSION = {
  IDLE: 'sl-main/auth/SESSION/idle',
  IN_PROGRESS: 'sl-main/auth/SESSION/pending',
  REJECTED: 'sl-main/auth/SESSION/rejected',
  RESOLVED: 'sl-main/auth/SESSION/resolved',
  EXPIRED: 'sl-main/auth/SESSION/expired',
  REFRESH: 'sl-main/auth/SESSION/refresh',
};
